import React from 'react';
import { cn } from '@/utils';

interface MaterialIconProps {
  icon: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Material Symbols Outlined icon component
 * Uses Google's Material Symbols font
 */
const MaterialIcon: React.FC<MaterialIconProps> = ({ icon, className, style }) => {
  return (
    <span 
      className={cn('material-symbols-outlined', className)}
      style={style}
    >
      {icon}
    </span>
  );
};

export default MaterialIcon;
